window.GUIDE = {
  id: 'madrid-style-patatas-bravas',

  title:
    'Lang1#Madrid-Style Patatas Bravas Lang2#Patatas bravas al estilo de Madrid',

  time: '55 min',

  servings:
    'Lang1#4 people Lang2#4 personas',

  difficulty:
    'Lang1#Medium Lang2#Media',

  settings: {
    autoplay: true,
    autoplayDelay: 10000,
    resumeDelay: 8000,
    loop: true,
    mobileBreakpoint: 900
  },

  attribution: {
    visible: true,
    text:
      'Lang1#Developed by la despensa · IAIAO Lang2#Desarrollada por la despensa · IAIAO'
  },

  recipeGuide: {
    visible: true,

    eyebrow:
      'Lang1#Madrid-Style Patatas Bravas Lang2#Patatas bravas al estilo de Madrid',

    title:
      'Lang1#Step-by-Step Cooking Guide Lang2#Guía de cocina paso a paso',

    intro:
      'Lang1#Keep the complete recipe close at hand while you cook. Lang2#Ten la receta completa a mano mientras cocinas.'
  },

  share: {
    visible: true,

    title:
      'Lang1#Share this Recipe Lang2#Comparte esta receta',

    text:
      'Lang1#Enjoyed this Madrid classic? Share it with friends and family. Lang2#¿Te ha gustado este clásico madrileño? Compártelo con familiares y amigos.',

    whatsappLabel: 'WhatsApp',

    emailLabel:
      'Lang1#Email Lang2#Correo electrónico',

    copyLabel:
      'Lang1#Copy Link Lang2#Copiar enlace'
  },

  otherIdeas: {
    visible: true,

    title:
      'Lang1#Other Ideas Lang2#Otras ideas',

    href:
      'https://ladespensa.ae/pages/valencian-paella-guide',

    image:
      'https://cdn.shopify.com/s/files/1/0784/2065/files/paell_cooking_guides.png?v=1785571523',

    alt:
      'Explore our paella cooking guides',

    buttonLabel:
      'Lang1#Discover More Lang2#Descubrir más'
  },

  shop: {
    visible: true,

    collectionHandle:
      'patatas-bravas-ingredients',

    eyebrow:
      'Lang1#Spanish Kitchen Lang2#Cocina española',

    title:
      'Lang1#Shop the Ingredients Lang2#Compra los ingredientes',

    text:
      'Lang1#The essential Spanish ingredients for recreating Madrid-style patatas bravas at home. Lang2#Los ingredientes españoles esenciales para preparar en casa unas patatas bravas al estilo de Madrid.',

    groups: [
      {
        key: 'paprika',
        value: 'skgc-paprika',
        number: '01',

        title:
          'Pimentón de la Vera',

        text:
          'Lang1#Sweet and hot smoked paprika create the colour, aroma and characteristic heat of the sauce. Lang2#El pimentón ahumado dulce y picante aporta el color, el aroma y el picor característicos de la salsa.'
      },

      {
        key: 'stock',
        value: 'skgc-stock',
        number: '02',

        title:
          'Lang1#Chicken Stock Lang2#Caldo de pollo',

        text:
          'Lang1#A light golden stock loosens the paprika roux and gives the sauce savoury depth. Lang2#Un caldo dorado y ligero diluye el roux de pimentón y aporta profundidad a la salsa.'
      },

      {
        key: 'olive-oil',
        value: 'skgc-olive-oil',
        number: '03',

        title:
          'Lang1#Extra Virgin Olive Oil Lang2#Aceite de oliva virgen extra',

        text:
          'Lang1#Choose a balanced extra virgin olive oil for the aromatic base and frying. Lang2#Elige un aceite de oliva virgen extra equilibrado para la base aromática y la fritura.'
      },

      {
        key: 'essentials',
        value: 'skgc-essential',
        number: '04',

        title:
          'Lang1#Kitchen Essentials Lang2#Esenciales de cocina',

        text:
          'Lang1#Complete the recipe with the remaining pantry essentials. Lang2#Completa la receta con el resto de ingredientes básicos de despensa.'
      }
    ],

    viewAllLabel:
      'Lang1#View Full Collection Lang2#Ver la colección completa'
  },

  slides: [
    {
      type: 'hero',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/1._Patats_bravas_hero.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/11._Patats_bravas_hero_Mobile.webp?v=1789725249',

        alt:
          'Madrid-style patatas bravas with a smooth paprika sauce'
      },

      content: {
        eyebrow:
          'Lang1#Spanish Kitchen · Guided Cooking Lang2#Cocina española · Receta guiada',

        title:
          'Lang1#Madrid-Style Patatas Bravas Lang2#Patatas bravas al estilo de Madrid',

        subtitle:
          'Lang1#Crisp potatoes. A silky paprika sauce. One iconic tapa. Lang2#Patatas crujientes. Una salsa sedosa de pimentón. Una tapa icónica.'
      },

      timer: false
    },

    {
      type: 'ingredients',

      chapter:
        'Lang1#Ingredients Lang2#Ingredientes',

      accordionImage: true,

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/2._Patats_bravas_Ingredients.webp?v=1789704077',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/12._Patats_bravas_Ingredients_Mobile.webp?v=1789725251',

        alt:
          'Ingredients and quantities for Madrid-style patatas bravas for four people'
      },

      content: {
        eyebrow: '',
        kicker: '',
        title: '',
        text: '',
        note: ''
      },

      timer: false
    },

    {
      type: 'step',

      chapter:
        'Lang1#Prepare the potatoes Lang2#Preparar las patatas',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/3._Patats_bravas_Preapare_the_potatoes.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/13._Patats_bravas_Preapare_the_potatoes_mobil.webp?v=1789725251',

        alt:
          'Cutting peeled potatoes into irregular pieces and soaking them in cold water'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Prepare the potatoes Lang2#Preparar las patatas',

        title:
          'Lang1#Cut, rinse and reserve Lang2#Cortar, lavar y reservar',

        text:
          'Lang1#Peel the potatoes and cut them into rustic, irregular pieces of about 3–4 cm. Rinse or soak them briefly in cold water, then drain. Lang2#Pela las patatas y córtalas en trozos rústicos e irregulares de unos 3–4 cm. Lávalas o déjalas brevemente en agua fría y escúrrelas.',

        mobileText:
          'Lang1#Cut into rustic 3–4 cm pieces, rinse and drain. Lang2#Corta en trozos rústicos de 3–4 cm, lava y escurre.',

        note:
          'Lang1#Dry the potatoes thoroughly before frying. Surface water causes dangerous splattering and prevents a crisp finish. Lang2#Seca muy bien las patatas antes de freírlas. El agua superficial provoca salpicaduras peligrosas e impide que queden crujientes.',

        mobileNote:
          'Lang1#Dry thoroughly before frying. Lang2#Seca muy bien antes de freír.'
      },

      timer: '10 min'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Build the sauce Lang2#Preparar la salsa',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/4._Patats_bravas_base_aromatica.webp?v=1789704074',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/14._Patats_bravas_base_aromatica_mobil.webp?v=1789725250',

        alt:
          'Onion and garlic gently cooking in extra virgin olive oil'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Build the sauce Lang2#Preparar la salsa',

        title:
          'Lang1#Begin with the aromatic base Lang2#Comenzar con la base aromática',

        text:
          'Lang1#Finely chop the onion and garlic. Cook them gently in extra virgin olive oil over low heat until soft and translucent. Lang2#Pica finamente la cebolla y el ajo. Póchalos suavemente en aceite de oliva virgen extra a fuego bajo hasta que estén tiernos y transparentes.',

        mobileText:
          'Lang1#Gently soften the chopped onion and garlic in EVOO. Lang2#Pocha suavemente la cebolla y el ajo en AOVE.',

        note:
          'Lang1#Do not brown the onion. Slow cooking gives the sauce sweetness without changing its clean paprika flavour. Lang2#No dejes que la cebolla se dore. La cocción lenta aporta dulzor sin alterar el sabor limpio del pimentón.',

        mobileNote:
          'Lang1#Keep the onion pale—do not brown it. Lang2#Mantén la cebolla clara; no la dores.'
      },

      timer: '8–10 min'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Build the sauce Lang2#Preparar la salsa',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/5._Patats_bravas_El_momento_del_pimenton.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/15._Patats_bravas_El_momento_del_pimenton_Mobile.webp?v=1789725250',

        alt:
          'Adding sweet and hot smoked Pimentón de la Vera to the onion base'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#The critical moment Lang2#El momento crítico',

        title:
          'Lang1#Awaken the paprika Lang2#Despertar el pimentón',

        text:
          'Lang1#Move the pan away from the strongest heat. Add one tablespoon each of sweet and hot smoked Pimentón de la Vera, then stir immediately. Lang2#Aparta la sartén del fuego más intenso. Añade una cucharada de Pimentón de la Vera dulce y otra de picante y remueve inmediatamente.',

        mobileText:
          'Lang1#Off the heat, add one spoon each of sweet and hot paprika. Lang2#Fuera del fuego, añade una cucharada de pimentón dulce y otra de picante.',

        note:
          'Lang1#Paprika burns in seconds and becomes bitter. Keep it moving and do not let it darken. Lang2#El pimentón se quema en segundos y amarga. No dejes de remover y evita que se oscurezca.',

        mobileNote:
          'Lang1#Stir immediately: paprika burns quickly. Lang2#Remueve enseguida: el pimentón se quema rápido.'
      },

      timer: '20 sec'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Build the sauce Lang2#Preparar la salsa',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/6._Patats_bravas_harina.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/16._Patats_bravas_harina_mobile.webp?v=1789725251',

        alt:
          'Adding one level tablespoon of flour to the paprika and onion mixture'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Build the sauce Lang2#Preparar la salsa',

        title:
          'Lang1#Add the flour Lang2#Añadir la harina',

        text:
          'Lang1#Add one level tablespoon of plain flour and stir continuously until it disappears into the paprika and olive oil. Lang2#Añade una cucharada rasa de harina de trigo y remueve continuamente hasta integrarla con el pimentón y el aceite de oliva.',

        mobileText:
          'Lang1#Stir in one level tablespoon of flour. Lang2#Incorpora una cucharada rasa de harina.',

        note:
          'Lang1#Cook it briefly to remove the raw flour taste while keeping the mixture moist and brick-red. Lang2#Cocínala brevemente para eliminar el sabor a harina cruda, manteniendo la mezcla húmeda y de color rojo teja.',

        mobileNote:
          'Lang1#Cook briefly without drying the mixture. Lang2#Cocina brevemente sin secar la mezcla.'
      },

      timer: '30 sec'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Build the sauce Lang2#Preparar la salsa',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/7._Patats_bravas_Construir_la_salsa.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/17._Patats_bravas_Construir_la_salsa_Mobil.webp?v=1789725250',

        alt:
          'Gradually adding light golden chicken stock to the paprika roux'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Build the sauce Lang2#Preparar la salsa',

        title:
          'Lang1#Add the stock little by little Lang2#Añadir el caldo poco a poco',

        text:
          'Lang1#Gradually pour in 400 ml of hot chicken stock (add two spoons of our Stock Base to 400 ml of water) while stirring continuously. Bring the mixture together into a smooth, light sauce. Lang2#Incorpora poco a poco 400 ml de caldo de pollo caliente (añade dos cucharadas de nuestro concentrado de caldo a 400 ml de agua), removiendo continuamente hasta obtener una salsa ligera y homogénea.',

        mobileText:
          'Lang1#Gradually stir in 400 ml of prepared hot chicken stock. Lang2#Incorpora poco a poco 400 ml de caldo de pollo caliente.',

        note:
          'Lang1#The sauce should remain fluid. Simmer gently and add a small splash of hot water if it becomes too thick. Lang2#La salsa debe quedar fluida. Cocina suavemente y añade un poco de agua caliente si espesa demasiado.',

        mobileNote:
          'Lang1#Keep the sauce light and fluid. Lang2#Mantén la salsa ligera y fluida.'
      },

      timer: '10 min'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Finish the sauce Lang2#Terminar la salsa',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/8._Patats_bravas_batidora.webp?v=1789704077',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/18._Patats_bravas_batidora_mobile.webp?v=1789725251',

        alt:
          'Blending the cooked brava sauce until completely smooth'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Finish the sauce Lang2#Terminar la salsa',

        title:
          'Lang1#Blend until silky Lang2#Triturar hasta conseguir una textura sedosa',

        text:
          'Lang1#Transfer the sauce to a tall heatproof container and blend until the onion and garlic disappear into a fine, glossy sauce. Lang2#Pasa la salsa a un recipiente alto y resistente al calor. Tritúrala hasta que la cebolla y el ajo desaparezcan y quede fina y brillante.',

        mobileText:
          'Lang1#Blend in a tall container until silky smooth. Lang2#Tritura en un recipiente alto hasta que quede sedosa.',

        note:
          'Lang1#Taste and adjust the salt. The finished sauce should coat a spoon but still pour in a smooth ribbon. Lang2#Prueba y ajusta de sal. La salsa terminada debe cubrir la cuchara y caer formando una cinta fluida.',

        mobileNote:
          'Lang1#Adjust the salt and texture. Lang2#Ajusta la sal y la textura.'
      },

      timer: '1–2 min'
    },

    {
      type: 'step',

      chapter:
        'Lang1#Fry until crisp Lang2#Freír hasta que estén crujientes',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/9._Patats_bravas_fry_the_potatoes.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/19._Patats_bravas_fry_the_potatoes_mobile.webp?v=1789725250',

        alt:
          'Frying irregular potato pieces until golden and crisp'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Fry until crisp Lang2#Freír hasta que estén crujientes',

        title:
          'Lang1#Soft inside. Golden outside. Lang2#Tiernas por dentro. Doradas por fuera.',

        text:
          'Lang1#Cook the dry potato pieces first at a moderate temperature until tender, then finish them briefly at a higher temperature until deeply golden and crisp. Lang2#Fríe primero las patatas bien secas a temperatura moderada hasta que estén tiernas. Termina la fritura brevemente a mayor temperatura hasta que queden bien doradas y crujientes.',

        mobileText:
          'Lang1#Fry gently until tender, then raise the heat until golden and crisp. Lang2#Fríe suavemente hasta que estén tiernas y termina a más temperatura.',

        note:
          'Lang1#Work in batches and avoid overcrowding the pan. Drain well and season with salt immediately. Lang2#Trabaja por tandas y no llenes demasiado la sartén. Escúrrelas bien y añade la sal inmediatamente.',

        mobileNote:
          'Lang1#Work in batches and salt immediately. Lang2#Fríe por tandas y sala inmediatamente.'
      },

      timer: '15–18 min'
    },

    {
      type: 'result',

      chapter:
        'Lang1#Dress and share Lang2#Salsear y compartir',

      image: {
        desktop:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/10._Patats_bravas_servir.webp?v=1789704075',

        mobile:
          'https://cdn.shopify.com/s/files/1/0784/2065/files/20._Patats_bravas_servir_Mobile.webp?v=1789725250',

        alt:
          'Pouring smooth brava sauce over freshly fried potatoes'
      },

      content: {
        eyebrow: '',

        kicker:
          'Lang1#Dress and share Lang2#Salsear y compartir',

        title:
          'Lang1#Sauce at the very last moment Lang2#Añadir la salsa en el último momento',

        text:
          'Lang1#Arrange the hot, crisp potatoes on a wide serving plate and pour the warm brava sauce over the centre just before serving. Lang2#Coloca las patatas calientes y crujientes en un plato amplio y vierte la salsa brava templada por el centro justo antes de servir.',

        mobileText:
          'Lang1#Pour the warm brava sauce over the potatoes just before serving. Lang2#Vierte la salsa brava templada justo antes de servir.',

        note:
          'Lang1#Be generous, but leave some golden edges uncovered so the potatoes stay crisp as everyone gathers around. Lang2#Sé generoso, pero deja algunos bordes dorados sin cubrir para que las patatas conserven el punto crujiente.',

        mobileNote:
          'Lang1#Leave some golden edges uncovered. Lang2#Deja algunos bordes dorados sin cubrir.'
      },

      timer: false
    }
  ]
};


/* =========================================================
   EDITORIAL SEO ACCORDION · UAE
========================================================= */

(function () {
  'use strict';

  function convertBilingualElement(element) {
    var markup = element.innerHTML;
    var lang1Start = markup.indexOf('Lang1#');
    var lang2Start = markup.indexOf('Lang2#');

    if (lang1Start === -1 || lang2Start === -1) {
      return;
    }

    var english = markup
      .slice(lang1Start + 6, lang2Start)
      .trim();

    var spanish = markup
      .slice(lang2Start + 6)
      .trim();

    element.innerHTML =
      '<span class="lang lang1 inline-block">' +
        english +
      '</span>' +
      '<span class="lang lang2 inline-block">' +
        spanish +
      '</span>';
  }


  function applyBravasMobileSlideCopy() {
    var guideRoot =
      document.getElementById(
        'spanish-kitchen-guide'
      );

    if (!guideRoot || !window.GUIDE) {
      return;
    }

    var useMobileCopy =
      window.matchMedia(
        '(max-width: 900px)'
      ).matches;

    window.GUIDE.slides.forEach(
      function (slide, index) {
        var content =
          slide.content || {};

        var slideElement =
          guideRoot.querySelector(
            '.skgc__slide[data-index="' +
            index +
            '"]'
          );

        if (!slideElement) {
          return;
        }

        [
          {
            selector: '.skgc__text',
            value: content.mobileText
          },
          {
            selector: '.skgc__note',
            value: content.mobileNote
          }
        ].forEach(
          function (item) {
            var element =
              slideElement.querySelector(
                item.selector
              );

            if (!element || !item.value) {
              return;
            }

            if (
              !element.hasAttribute(
                'data-bravas-original-html'
              )
            ) {
              element.setAttribute(
                'data-bravas-original-html',
                element.innerHTML
              );
            }

            if (useMobileCopy) {
              element.textContent =
                item.value;

              convertBilingualElement(
                element
              );
            } else {
              element.innerHTML =
                element.getAttribute(
                  'data-bravas-original-html'
                );
            }
          }
        );
      }
    );
  }


  function mountBravasEditorial() {
    var guide =
      document.getElementById(
        'spanish-kitchen-guide'
      );

    var shop =
      guide &&
      guide.querySelector(
        '.skgc-ingredients'
      );

    if (
      !guide ||
      !shop ||
      document.getElementById(
        'bravas-editorial-story'
      )
    ) {
      return;
    }

    var editorial =
      document.createElement(
        'section'
      );

    editorial.id =
      'bravas-editorial-story';

    editorial.className =
      'bravas-editorial';

    editorial.innerHTML = `
      <div class="bravas-editorial__summary">

        <div class="bravas-editorial__eyebrow">
          Lang1#Spanish Kitchen · Madrid Tapas
          Lang2#Cocina española · Tapas de Madrid
        </div>

        <h2>
          Lang1#Patatas Bravas: Madrid’s Iconic Tapa, Now in Your UAE Kitchen
          Lang2#Patatas bravas: la tapa icónica de Madrid, ahora en tu cocina en UAE
        </h2>

        <p>
          Lang1#Few dishes capture the spirit of Madrid’s tapas bars as instantly
          as <strong>patatas bravas</strong>: crisp golden potatoes, a warm and
          silky paprika sauce and the pleasure of sharing a plate around the
          table.
          Lang2#Pocos platos representan tan bien el espíritu de las barras
          madrileñas como las <strong>patatas bravas</strong>: patatas doradas y
          crujientes, una salsa de pimentón cálida y sedosa y el placer de
          compartir un plato alrededor de la mesa.
        </p>

        <p>
          Lang1#Every cook has a personal method — <em>cada maestrillo tiene su
          librillo</em> — and now you can prepare this emblematic Spanish tapa at
          home and travel back to Madrid without leaving the UAE.
          Lang2#Cada maestrillo tiene su librillo y ahora tú también puedes
          preparar esta emblemática tapa española en casa y viajar de vuelta a
          Madrid sin salir de los Emiratos.
        </p>

      </div>

      <div
        id="bravas-editorial-full"
        class="bravas-editorial__full"
        hidden
      >

        <h3>
          Lang1#From Madrid’s tapas bars to tables across Spain
          Lang2#De las barras de Madrid a las mesas de toda España
        </h3>

        <p>
          Lang1#Patatas bravas occupy a special place in the culture of
          <strong>tapeo in Madrid</strong>. They are uncomplicated, generous and
          social: exactly the kind of dish that invites another conversation,
          another plate for the table and another moment together. Although
          closely associated with Madrid, bravas have become an essential part
          of tapas culture throughout Spain.
          Lang2#Las <strong>patatas bravas</strong> ocupan un lugar privilegiado
          en la cultura del tapeo madrileño. Son sencillas, generosas y sociales:
          una de esas tapas que invitan a alargar la conversación, pedir otro
          plato para compartir y disfrutar de la buena compañía. Aunque están
          profundamente vinculadas a Madrid, hoy forman parte esencial del tapeo
          en toda España.
        </p>

        <p>
          Lang1#There is no single sauce interpreted identically everywhere.
          Some versions are sharper, others hotter or creamier; some arrive with
          alioli, while traditional Madrid-style preparations often obtain their
          characteristic red colour from paprika rather than tomato. That
          variety is part of their charm: every bar, family and cook has a
          preferred balance of spice, texture and generosity.
          Lang2#No existe una única salsa interpretada exactamente igual en todas
          partes. Algunas versiones son más intensas, otras más picantes o
          cremosas; algunas incorporan alioli, mientras que las elaboraciones
          tradicionales de estilo madrileño suelen obtener su característico
          color rojizo del pimentón y no del tomate. Ahí reside parte de su
          encanto: cada bar, cada familia y cada cocinero encuentra su propio
          equilibrio.
        </p>

        <p>
          Lang1#In this guided recipe, sweet and hot smoked
          <strong>Pimentón de la Vera</strong>, onion, garlic, flour and chicken
          stock become a smooth, brick-red sauce. It is poured over the potatoes
          only at the last moment, leaving enough golden edges uncovered to
          preserve their crispness.
          Lang2#En esta receta guiada, el <strong>Pimentón de la Vera dulce y
          picante</strong>, la cebolla, el ajo, la harina y el caldo de pollo se
          transforman en una salsa fina, sedosa y de color rojo teja. La salsa se
          añade únicamente en el último momento, dejando algunos bordes dorados
          al descubierto para conservar el punto crujiente.
        </p>

        <p>
          Lang1#At <strong>la despensa UAE</strong>, we make authentic Spanish
          cooking accessible in Dubai, Abu Dhabi and across the Emirates. With
          the right Spanish paprika, extra virgin olive oil and a few everyday
          ingredients, you can recreate one of Madrid’s most recognisable tapas
          at home.
          Lang2#En <strong>la despensa UAE</strong> acercamos la cocina española
          auténtica a Dubai, Abu Dhabi y al resto de los Emiratos. Con un buen
          pimentón español, aceite de oliva virgen extra y unos pocos
          ingredientes cotidianos, puedes preparar en casa una de las tapas más
          reconocibles de Madrid.
        </p>

        <blockquote>
          <strong>
            Lang1#Make them your way, gather good company around the table and
            let the first bite take you back to Madrid.
            Lang2#Hazlas a tu manera, reúne buena compañía alrededor de la mesa
            y deja que el primer bocado te lleve de vuelta a Madrid.
          </strong>
        </blockquote>

      </div>

      <button
        class="bravas-editorial__toggle"
        type="button"
        aria-expanded="false"
        aria-controls="bravas-editorial-full"
      >

        <span class="bravas-editorial__toggle-more">
          Lang1#Read more Lang2#Leer más
        </span>

        <span
          class="bravas-editorial__toggle-less"
          hidden
        >
          Lang1#Show less Lang2#Mostrar menos
        </span>

        <span
          class="bravas-editorial__toggle-symbol"
          aria-hidden="true"
        >
          +
        </span>

      </button>
    `;

    editorial
      .querySelectorAll(
        '.bravas-editorial__eyebrow, h2, h3, p, blockquote, .bravas-editorial__toggle-more, .bravas-editorial__toggle-less'
      )
      .forEach(
        convertBilingualElement
      );

    var fullText =
      editorial.querySelector(
        '.bravas-editorial__full'
      );

    var toggle =
      editorial.querySelector(
        '.bravas-editorial__toggle'
      );

    var moreLabel =
      editorial.querySelector(
        '.bravas-editorial__toggle-more'
      );

    var lessLabel =
      editorial.querySelector(
        '.bravas-editorial__toggle-less'
      );

    var symbol =
      editorial.querySelector(
        '.bravas-editorial__toggle-symbol'
      );

    toggle.addEventListener(
      'click',
      function () {
        var isOpen =
          toggle.getAttribute(
            'aria-expanded'
          ) === 'true';

        toggle.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );

        fullText.hidden =
          isOpen;

        moreLabel.hidden =
          !isOpen;

        lessLabel.hidden =
          isOpen;

        symbol.textContent =
          isOpen
            ? '+'
            : '−';
      }
    );

    shop.parentNode.insertBefore(
      editorial,
      shop
    );
  }


  function addBravasEditorialStyles() {
    if (
      document.getElementById(
        'bravas-editorial-styles'
      )
    ) {
      return;
    }

    var style =
      document.createElement(
        'style'
      );

    style.id =
      'bravas-editorial-styles';

    style.textContent = `
      @media (max-width: 900px) {
        #spanish-kitchen-guide
        .skgc__slide[data-index="2"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="3"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="4"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="5"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="6"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="7"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="8"]
        .skgc__content,
        #spanish-kitchen-guide
        .skgc__slide[data-index="9"]
        .skgc__content {
          top: 76px !important;
          bottom: auto !important;
          max-height: calc(100% - 235px);
        }

        #spanish-kitchen-guide
        .skgc__slide[data-index="1"]
        .skgc__image {
          object-fit: contain !important;
          object-position: center center !important;
          background: #f7f1e7;
        }

        #spanish-kitchen-guide
        .skgc__slide[data-index="1"]
        .skgc__shade {
          background:
            linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.38),
              rgba(0, 0, 0, 0) 24%
            );
        }
      }

      .bravas-editorial {
        width: 85%;
        max-width: 1200px;
        margin: 70px auto 72px;
        color: #0b2f47;
      }

      .bravas-editorial__eyebrow {
        margin-bottom: 14px;
        color: #972735;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        line-height: 1.2;
        font-weight: 700;
        letter-spacing: 0.14em;
        text-transform: uppercase;
      }

      .bravas-editorial h2 {
        max-width: 920px;
        margin: 0 0 24px;
        color: #0b2f47;
        font-family: Georgia, 'Times New Roman', serif;
        font-size: clamp(32px, 4.2vw, 58px);
        line-height: 1.06;
        font-weight: 400;
      }

      .bravas-editorial h3 {
        margin: 34px 0 16px;
        color: #0b2f47;
        font-family: Georgia, 'Times New Roman', serif;
        font-size: clamp(24px, 2.8vw, 36px);
        line-height: 1.15;
        font-weight: 400;
      }

      .bravas-editorial p,
      .bravas-editorial blockquote {
        max-width: 920px;
        margin: 0 0 18px;
        font-family: Arial, Helvetica, sans-serif;
        font-size: clamp(16px, 1.25vw, 18px);
        line-height: 1.72;
      }

      .bravas-editorial blockquote {
        margin: 30px 0;
        padding: 22px 26px;
        border-left: 3px solid #c8a45d;
        background: #f7f1e7;
      }

      .bravas-editorial__full[hidden] {
        display: none;
      }

      .bravas-editorial__toggle {
        display: inline-flex;
        align-items: center;
        gap: 14px;
        margin-top: 12px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #972735;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 13px;
        line-height: 1.2;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        cursor: pointer;
      }

      .bravas-editorial__toggle-symbol {
        display: grid;
        width: 30px;
        height: 30px;
        place-items: center;
        border: 1px solid rgba(151, 39, 53, 0.45);
        border-radius: 50%;
        font-size: 20px;
        line-height: 1;
        font-weight: 400;
      }

      @media (max-width: 749px) {
        .bravas-editorial {
          width: calc(100% - 40px);
          margin: 48px auto 52px;
        }

        .bravas-editorial h2 {
          font-size: clamp(30px, 9vw, 42px);
        }

        .bravas-editorial p,
        .bravas-editorial blockquote {
          font-size: 16px;
          line-height: 1.68;
        }

        .bravas-editorial blockquote {
          padding: 20px;
        }
      }
    `;

    document.head.appendChild(
      style
    );
  }


  document.addEventListener(
    'DOMContentLoaded',
    function () {
      window.setTimeout(
        function () {
          addBravasEditorialStyles();
          applyBravasMobileSlideCopy();
          mountBravasEditorial();
        },
        0
      );
    }
  );

  window.addEventListener(
    'resize',
    applyBravasMobileSlideCopy
  );

})();
